import { createActions, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

import * as loadingState from '@coconut/constants/loadingState';

import { NOT_YET_BEGUN } from '../constants/answerStages';

export const types = {
  FETCH_ANSWER_STAGE: 'FETCH_ANSWER_STAGE',
  FETCH_ANSWER_STAGE_SUCCESS: 'FETCH_ANSWER_STAGE_SUCCESS',
  FETCH_ANSWER_STAGE_FAILED: 'FETCH_ANSWER_STAGE_FAILED',
  SET_ANSWER_STAGE: 'SET_ANSWER_STAGE',
  SET_ANSWER_STAGE_FAILED: 'SET_ANSWER_STAGE_FAILED',
  RESET_ANSWER_STAGE: 'RESET_ANSWER_STAGE',
  UPDATE_ANSWER_STAGE: 'UPDATE_ANSWER_STAGE',
};

export const {
  fetchAnswerStage,
  fetchAnswerStageSuccess,
  fetchAnswerStageFailed,
  setAnswerStage,
  setAnswerStageFailed,
  resetAnswerStage,
  updateAnswerStage,
} = createActions(
  {
    [types.FETCH_ANSWER_STAGE]: (QID) => ({
      QID,
    }),
    [types.FETCH_ANSWER_STAGE_SUCCESS]: ({ expireAt, answerStage }) => ({
      expireAt,
      answerStage,
    }),
    [types.FETCH_ANSWER_STAGE_FAILED]: (errorMessage) => ({
      errorMessage,
    }),
    [types.SET_ANSWER_STAGE]: ({ QID, action }) => ({
      QID,
      action,
    }),
    [types.SET_ANSWER_STAGE_FAILED]: (errorMessage) => ({
      errorMessage,
    }),
    [types.UPDATE_ANSWER_STAGE]: (stage) => ({
      stage,
    }),
  },
  types.RESET_ANSWER_STAGE
);

const INIT_STATE = {
  loadingStatus: loadingState.EMPTY,
  stage: NOT_YET_BEGUN,
  expireAt: 0,
  errorMessage: '',
};

const reducer = handleActions(
  {
    [types.FETCH_ANSWER_STAGE]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
    }),
    [types.FETCH_ANSWER_STAGE_SUCCESS]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.READY,
      stage: action.payload.answerStage,
      expireAt: action.payload.expireAt,
      errorMessage: '',
    }),
    [types.FETCH_ANSWER_STAGE_FAILED]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
    [types.SET_ANSWER_STAGE]: (state) => ({
      ...state,
      loadingStatus: loadingState.LOADING,
    }),
    [types.SET_ANSWER_STAGE_FAILED]: (state, action) => ({
      ...state,
      loadingStatus: loadingState.ERROR,
      errorMessage: action.payload.errorMessage,
    }),
    [types.RESET_ANSWER_STAGE]: () => ({
      ...INIT_STATE,
    }),
    [types.UPDATE_ANSWER_STAGE]: (state, action) => ({
      ...state,
      stage: action.payload.stage,
    }),
  },
  INIT_STATE
);

export default reducer;

export const getAnswerStage = (state) => state.chat.answerStage;
export const getAnswerStageExpireAt = createSelector(
  getAnswerStage,
  (answerStage) => answerStage.expireAt
);
export const getCurrentAnswerStage = createSelector(
  getAnswerStage,
  (answerStage) => answerStage.stage
);



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/answerStage.js